module.exports = __webpack_public_path__ + "src/assets/images/accident-management/icon-finance-management.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accident-management/icon-finance-management.jpg
// module id = 2310
// module chunks = 4